import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=0b0ede60&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./EmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=0b0ede60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ede60",
  null
  
)

export default component.exports